module.exports = __webpack_public_path__ + "static/img/bg9.5355e3c1.png";